import React from "react";

const Tabs = (props) => {
  const { tabOptions, selectedTab, handleTab } = props;

  return (
    <div className={`flex justify-between mt-[20px] mb-[16px]`}>
      {tabOptions.map((option, i) => (
        <div
          key={i}
          onClick={() => handleTab(option)}
          className={`w-full border-b-2 text-center text-[14px] pb-[8px] ${
            option.text === selectedTab.text
              ? "border-[#1C75BC] text-[#1C75BC] font-semibold"
              : "border-[#E0E0E0]"
          }`}
        >
          {option.text}
        </div>
      ))}
    </div>
  );
};

export default Tabs;
